/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

export default {
    baseStyle: ({isDisabled}) => ({
        container: {
            display: 'flex',
            flexDirection: 'column',
            color: 'stokkeCore.black',
            ...(isDisabled && {
                cursor: 'not-allowed'
            }),
            sx: {
                '&:hover [data-not-hovered="container"]': {
                    display: 'none'
                },
                '&:not(:hover) [data-hovered="container"]': {
                    display: 'none'
                }
            }
        },
        imageContainer: {
            position: 'relative'
        },
        unavailableImageContainer: {
            placeSelf: 'stretch',
            width: '100%',
            height: '100%',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            paddingInline: 3,

            gap: 3,
            color: 'stokkeGray.accessibleText',
            backgroundColor: 'stokkeGray.light'
        },
        unavailableIconBox: {position: 'relative'},
        closeIconRound: {
            position: 'absolute',
            top: '-0.28rem',
            right: '-0.32rem',
            bg: 'stokkeGray.accessibleText',
            display: 'flex',
            width: '0.75rem',
            height: '0.75rem',
            padding: '3px',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 'full'
        },
        unavailableText: {
            maxWidth: '11.25rem',
            textAlign: 'center',
            textStyle: 'Regular Small'
        },
        imageOverlay: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: '100%',
            height: '100%',
            pointerEvents: 'none'
        },
        badgesContainer: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            justifyContent: 'flex-end',
            alignItems: 'flex-start',
            padding: {base: 2, md: 3},
            gap: 1
        },
        overlayCta: {
            variant: 'unstyled',
            position: 'absolute',
            bottom: 0,
            right: 0,
            width: '45px',
            height: '45px',
            display: 'inline-flex',
            alignItems: 'flex-end',
            justifyContent: 'flex-end',
            padding: 2
        },
        infoContainer: {
            flexDirection: 'column',
            flexGrow: 1,
            paddingBlock: 3,
            gap: 3
        },
        primaryInfoContainer: {
            flexDirection: 'column',
            paddingInline: 1,
            gap: 2
        },
        title: {
            textStyle: 'Product Tile',
            isTruncated: true,
            noOfLines: 2,
            whiteSpace: 'normal'
        },
        variations: {
            listProps: {
                display: 'flex',
                flexWrap: 'wrap',
                columnGap: {base: 2, lg: 1},
                rowGap: 2,
                paddingInlineStart: 0.5,
                paddingInlineEnd: {base: 2, lg: 0.5}
            }
        },
        ctaAction: {
            variant: 'outline',
            marginTop: 'auto',
            marginBottom: 3
        }
    }),
    variants: {
        default: ({theme}) => ({
            imageOverlay: {
                backgroundImage: theme.gradients.greyBackgroundOfProductImages
            },
            title: {
                as: 'h3'
            }
        }),
        basic: ({theme}) => ({
            imageOverlay: {
                backgroundImage: theme.gradients.greyBackgroundOfProductImages
            },
            title: {
                as: 'h3'
            }
        }),
        order: ({theme}) => ({
            imageOverlay: {
                backgroundImage: theme.gradients.greyBackgroundOfProductImages
            },
            title: {
                as: 'p'
            }
        }),
        wishlist: {
            unavailableImageContainer: {
                backgroundColor: 'stokkeCore.white'
            },
            primaryInfoContainer: {
                paddingInline: 2
            },
            title: {
                as: 'h2'
            }
        }
    },
    parts: [
        'container',
        'imageContainer',
        'unavailableImageContainer',
        'unavailableIconBox',
        'closeIconRound',
        'unavailableText',
        'imageOverlay',
        'badgesContainer',
        'infoContainer',
        'primaryInfoContainer',
        'title',
        'variations',
        'ctaAction'
    ]
}
